import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Badge from './Badge';

const SelectCustomers = ({ apiUrl, selectedItem, setSelectedItem, NoContract }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  useEffect(() => {
    if (query.length < 3) {
      setResults([]);
      setIsDropdownOpen(false);
      return;
    }

    const fetch = async () => {
      try {
        const response = await axios.post(apiUrl, {
          data: { search: query, active_contract: NoContract },
          status: 'getCustomerList',
          headers: { 'Content-Type': 'application/json' },
        });
        setResults(response.data || []);
        setIsDropdownOpen(true);
      } catch (err) {
        console.error('Error fetching customers:', err);
      }
    };

    clearTimeout(debounceTimeout);
    setDebounceTimeout(setTimeout(fetch, 300));
  }, [query, apiUrl]);

  const handleSelect = (item) => {
    setSelectedItem(item);
    setQuery(item.full_address);
    setIsDropdownOpen(false);
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-gray-700">
        Job Site <span className="text-red-500">*</span>
      </label>
      <div className="relative">
        <input
          type="text"
          className="mt-1 block w-full border rounded py-2 px-3 focus:ring-2 focus:ring-indigo-600"
          placeholder="Start typing job site..."
          value={query || selectedItem?.full_address || ''}
          onChange={(e) => {
            setQuery(e.target.value);
          }}
        />
        {isDropdownOpen && results.length > 0 && (
          <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-auto divide-y">
            {results.map((item) => {
              const statusClass = item.status === 0 ? 'bg-red-100 hover:bg-red-200' : 'hover:bg-gray-100';
              return (
                <li
                  key={item.id}
                  onClick={() => handleSelect(item)}
                  className={`px-4 py-2 cursor-pointer ${statusClass}`}
                >
                  {item.contract_status === 0 && (
                    <div className="text-red-700 text-xs mb-1">********** Inactive **********</div>
                  )}
                  {item.contract_hold_amount > 0 && (
                    <div className="text-red-700 text-xs mb-1">********** On Hold **********</div>
                  )}
                  <div className="text-sm font-medium text-blue-900">
                    {item.hold === 1 && <Badge color="pink" feed="On Hold" />}
                    <span className="bg-yellow-50 px-1">{item.customer_name}</span><br/>
                            {item.system_type && (<>{item.system_type} | </>)}
                            {item.contract_type && (<>{item.contract_type}</>)}
                  </div>
                  <div className="text-sm">{item.full_address}</div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default SelectCustomers;
